export default (state = [], action) => {
    switch (action.type) {
        case 'PRODUCTS_FETCH_SUCCESS':
            return Object.values(action.products);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/productReducers.js